export default function CheckBox({
  className,
  label,
  value,
  onChange
}) {

  return (

    <div className={ cn('flex items-center space-x-2', className) }>
      <div className='cursor-pointer pt-[0.1rem]'>
        <input
          onChange={ () => onChange(!value) }
          checked={ value }
          type='checkbox'
        />
      </div>
      <div className='cursor-pointer' onClick={ () => onChange(!value) }>{ label }</div>
    </div>

  )
}
